import styled from 'styled-components';

/**
 * One way to collect, outlined in the brand red while ticked, like the SaaS
 * fee rows in the merchant app. The amount field sits under the label, not
 * inside it: inside, every click into the field would untick the method.
 */
export const MethodRow = styled.div<{ $ticked: boolean }>`
  padding: 12px 16px;
  border-radius: 14px;
  text-align: left;
  background: ${({ theme }) => theme.white};
  border: 1px solid
    ${({ $ticked, theme }) => ($ticked ? theme.primary : theme.mediumGray)};
  transition: ${({ theme }) => theme.transitions.ease200ms};
`;

/** A label, so a click anywhere on the title or the text ticks it. */
export const MethodLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
`;

/** The checkmark sits on the title's line, not centred on the whole text. */
export const MethodCheck = styled.div`
  flex: none;
  padding-top: 1px;
`;

/**
 * Lined up with the text above it: checkmark (24px) plus the gap. The space
 * above it comes from the collapsible it sits in, so a closed one takes none.
 */
export const MethodExtra = styled.div`
  margin-left: 36px;
`;
